if($('header').length){

    $('.navigation-buttons').prepend($('.top-navigation-tools .dropdown').clone())
    $('.responsive-tools').prepend($('.top-navigation-tools .dropdown').clone())
    $('.navigation-buttons').prepend('<a href="#" class="toggle-window" data-target="search" data-testid="linkSearchIcon"></a>')
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools')
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    function checkAndDisplaySVG(url, container) {
        var svgName = url.replace(/\//g, '');
        var svgUrl = '/user/documents/upload/menu-images/' + svgName+'.svg';
        var img = new Image();
        img.onload = function() {
            $(container).html(img);
        };
        img.onerror = function() {
        };
        img.src = svgUrl; 
    }
    $('.menu-level-1>li>a').each(function(){
        $(this).prepend('<div class="svg-container"></div>')
         var url = $(this).attr('href');
         var container = $(this).parent().find('.svg-container');
         checkAndDisplaySVG(url, container);
    })
    if($('.top-navigation-bar .top-navigation-tools a[href="/klient/"]').length){
        $('.headerRight a[href="/login/"]').text('Můj účet');
        $('.headerRight a[href="/registrace/"]').attr('style', 'opacity:0.2;pointer-events:none;')
    }

    $(document).on("click", ".search .close", function(){
        $('body').removeClass('user-action-visible search-window-visible')
        $('header#header .search input.search-input').val('')
    })
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        if (!(clickedElement.closest('.search').length || clickedElement.is('a[data-target="search"]'))) {
            $('body').removeClass('search-window-visible user-action-visible');
            $('header#header .search input.search-input').val('')
        }
        
    });
    $('<span class="close"></span>').appendTo('.search');
    $('header#header').before($('.header-top .search').clone().addClass('customSearch'))
}